import { Text } from '@wix/design-system';
import React from 'react';
import { getEditorCapabilitiesForHost } from '../../utils/editor-host-to-editor-type';
import { buildStudioDialogProps } from './build-studio-dialog-props';
export const showErrorModal = async _ref => {
  let {
    title,
    content,
    primaryButtonText,
    secondaryButtonText,
    primaryButtonOnClick,
    secondaryButtonOnClick,
    onClose,
    a11yWizardAdapter,
    skin = 'destructive',
    editorHost
  } = _ref;
  const {
    usesClassicModalChrome
  } = getEditorCapabilitiesForHost(editorHost);
  const contentByHost = usesClassicModalChrome ? content : /*#__PURE__*/React.createElement(Text, null, content);
  const modalProps = {
    content: contentByHost,
    onCloseButtonClick: () => {
      var _ref2;
      return (_ref2 = onClose ?? secondaryButtonOnClick) == null ? void 0 : _ref2();
    },
    primaryButtonOnClick,
    primaryButtonText,
    secondaryButtonOnClick,
    secondaryButtonText,
    skin,
    title
  };
  if (usesClassicModalChrome) {
    const classicDialogProps = {
      ...modalProps,
      theme: skin
    };
    await a11yWizardAdapter.showDialog(classicDialogProps);
    return;
  }
  await a11yWizardAdapter.showDialog(...buildStudioDialogProps(modalProps));
};
//# sourceMappingURL=show-error-modal.js.map